import { isEmpty, fireAnalyticsEvent } from '@myap/ui-library'
import useStudentInfo from './useStudentInfo'
import { USER_PROMPT_MODAL_ACTION } from '../components/scoresend/constants'

const useAnalyticsStudentScoreSendSelectRecipientEvent = ({ userPromptType }) => {
  const { appUser } = useStudentInfo()

  useEffect(() => {
    if (!isEmpty(appUser) && userPromptType === USER_PROMPT_MODAL_ACTION) {
      fireAnalyticsEvent({
        testing: false,
        disabled: false,
        eventData: {
          appUser,
          appPage: {
            domain: 'student',
            page: 'select-recipient',
            view: '',
            group: 'free-score-send',
          },
        },
      })
    }
  }, [appUser, userPromptType])

  return null
}

export default useAnalyticsStudentScoreSendSelectRecipientEvent
